import { updateProviderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateProviderCallable = getCallable(updateProviderDefinition);
